
import React from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import ServiceDetail from '../../ownerSpa/serviceDetail';
import { styles } from './styles';


class ServiceOwner extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading : true,
        }
    }
    componentDidMount() {
        const {adminService = {}} = this.props;
        if(!adminService || !adminService.name) {
            const parsed = queryString.parse(this.props.location.search);
            if(parsed.serviceCode) this.props.getServiceByCode({no: parsed.serviceCode})
        }
    }
    render() {  
        const {t, adminService = {}, ...props} = this.props;
        return (
            <ServiceDetail {...props} service={adminService} disabled={this.props.disabled}/> 
        ); 
    }
}
  
ServiceOwner.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapState = state => ({
    adminService : state.service.adminService,
    role: state.user.user.roleId.role,
});

const mapDispatch = dispatch => ({
    getServiceByCode: dispatch.service.getServiceByCode,
});

export default connect(mapState, mapDispatch)(translate('translations')(withStyles(styles, { withTheme: true })(ServiceOwner)));